import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 24px 0 16px 0;

  & > span {
    color: ${({ theme }) => theme.colors.grayDark};
    font-weight: 600;
    font-size: 0.875rem;
    margin-bottom: 0.5rem;
  }

  & .ant-row > .ant-radio-wrapper {
    color: ${({ theme }) => theme.colors.graySubTitle};
    font-size: 0.875rem;
  }

  .hefesto-chip {
    .mdc-chip-set.mdc-chip-set--choice {
      gap: 16px !important;
      padding: 0;
    }
  }
`;
